import type { Dict } from '../utils'
import type { CardProps } from './card.types'

import Box from '../box'
import { omitThemingProps, useStyleConfig, vui } from '../core'
import { cs } from '../utils'

/**
 * Displays static, partially interactive or fully interactive content, such as text, images or buttons.
 * Supports use cases like a single card or multiple tiles.
 */
export const Card = vui<'div', CardProps>((props, ref) => {
  const { className, isInteractive = props.onClick !== undefined, ...rest } = omitThemingProps(props)

  const styles = useStyleConfig('Card', props)

  const interactiveProps: Dict = isInteractive
    ? {
        cursor: 'pointer',
        focusRing: 2,
        hoverRingColor: 'seaBlue.main',
        outline: 'none',
        tabIndex: 0,
        userSelect: 'none',
      }
    : {}

  return <Box className={cs('vui-card', className)} ref={ref} {...styles} {...interactiveProps} {...rest} />
})

Card.displayName = 'Card'
export default Card
